import { useState, useEffect, useCallback } from 'react';
import { MiCuentaContext } from 'contexts';
import { useLocalStorage } from 'hooks';

export function MiCuentaProvider({ children }) {
    const [montoPendiente, setMontoPendiente] = useState('');
    const [montoColor, setMontoColor] = useState('');
    const [montoTotal, setMontoTotal] = useState('');

    return (
        <MiCuentaContext.Provider value={{
            montoPendiente,
            setMontoPendiente,
            montoColor,
            setMontoColor,
            montoTotal,
            setMontoTotal,
        }}>
            {children}
        </MiCuentaContext.Provider>
    );
}
